module.exports = __webpack_public_path__ + "img/gestionCVCNutriNeo.65360ad6.jpg";